module.exports = __webpack_public_path__ + "media/images/flags/64/Red-Cross-6a7b2af2214621c9d353c832bcb412b7.png";